export default {

    background: "#e9eaee",
    backgroundSecondary: "#eeeeee",

    primary: "#10734a",
    primaryDark: "#004622",
    primaryLight: "#4aa276",

    textOnPrimary: "#ffffff",

    fundoPage: "#ffffff",
    fundoIconeHome: "#f8f8f7",
    fundoHomeEmpresa: "#0d6781",

    buttonPrimary: "#004622",
    buttonSecondary: "#4aa276",

    accent: "#212121",
    accentDark: "#000000",
    accentLight: "#484848",
    textOnAccent: "#ffffff",

    textPrimaryDark: "#000000DD", // 87%
    textSecondaryDark: "#00000089", // 54%
    textDisabledDark: "#00000060", // 38%
    textHintDark: "#00000060", // 38%
    dividerDark: "#0000001F", // 12%

    textPrimaryLight: "#ffffff", // 100%
    textSecondaryLight: "#ffffffB2", // 70%
    textDisabledLight: "#ffffff7F", // 50%
    textHintLight: "#ffffff7F", // 50%
    dividerLight: "#ffffff3d", // 24%

    transparent: "#00000000",
};


// WEBPACK FOOTER //
// ./src/utils/Colors.js